import React from 'react'
import Title from './Title'
import Text from './Text'

export default function Goal () {
  return (
    <>
      <Title text={"Nous facilitons l'accès à la santé"} />
      <Text
        text={`Pour répondre à la diminution de l'offre de soin traditionnelle et permettre au plus grand nombre 
          d'avoir accès à un service de santé de proximité, nous avons créé la Box Médicale.`}
      />
    </>
  )
}
